import {
  Home,
  Building2,
  Hammer,
  Wrench,
  Paintbrush,
  Layers,
  BrickWall,
} from 'lucide-react';

const ICON_MAP = {
  home: Home,
  building2: Building2,
  hammer: Hammer,
  wrench: Wrench,
  paintbrush: Paintbrush,
  layers: Layers,
  brick: BrickWall,
};

export function resolveServiceIcon(slug = 'home') {
  return ICON_MAP[slug] || Home;
}
